// extracted by mini-css-extract-plugin
module.exports = {"actionArea":"Offer_actionArea__Ci-uV","ContactPhoneButton":"Offer_ContactPhoneButton__3-6dd"};